export const UngradedLabItemActionNames = {
  SetUngradedLab: 'UNGRADED_LAB_SET_UNGRADED_LAB',
  ClearUngradedLab: 'UNGRADED_LAB_CLEAR_UNGRADED_LAB',
} as const;

export type UngradedLabItemActionName = (typeof UngradedLabItemActionNames)[keyof typeof UngradedLabItemActionNames];
